export default __webpack_public_path__ + "static/media/cover_turuleka2.828fa1e4.mp4";